import {
  Box,
  Button,
  Card,
  CircularProgress,
  Dialog,
  DialogActions,
  DialogContent,
  Typography,
} from "@mui/material";
import React, { Suspense, useEffect } from "react";
import SuspenseLoading from "../../../common/SuspenseLoading";
import CreatePostStepper from "../../CreatePost/CreatePostStepper";
import CreatePostSelectTemplate from "../../CreatePost/CreatePostSelectTemplate";
import PostPreviewModal from "../PostPreviewModal";
import CreatePostActionFooter from "../../CreatePost/CreatePostActionFooter";

const RepostAJobModal = ({
  open,
  post,
  user,
  onClose,
  company,
  activeStep,
  activeSubStep,
  setActiveStep,
  onNext,
  setSuccessModal,
  steps,
  triggerValidation,
  setTriggerValidation,
  loading,
  setActiveSubStep,
  flag,
}) => {
  return (
    <Dialog
      onClose={onClose}
      open={open}
      sx={{
        "& .MuiDialog-paper": {
          padding: 0,
          margin: 0,
          overflow: { xs: "auto", lg: "hidden" },
          maxWidth: "none",
          maxHeight: "95vh",
          borderRadius: "10px",
          width: { xs: "98vw", lg: "90vw" },
        },
      }}
    >
      <DialogContent
        sx={{
          padding: 0,
        }}
      >
        <Box
          sx={{
            height: "100%",
            display: "flex",
            flexDirection: "column",
            borderRadius: "10px",
          }}
        >
          <Box sx={{ display: "flex", flex: 1 }}>
            <Box
              py={1}
              px={1.5}
              minWidth="17%"
              display={{ xs: "none", lg: "initial" }}
              sx={{
                backgroundColor: "#F7F8F9",
                overflow: "auto",
              }}
            >
              <Typography fontSize="1.2rem" p={1.5} fontWeight={500}>
                Steps
              </Typography>
              <Suspense
                fallback={<SuspenseLoading width="100%" height="90%" />}
              >
                <CreatePostStepper
                  steps={steps}
                  activeStep={activeStep}
                  activeSubStep={activeSubStep}
                />
              </Suspense>
            </Box>

            <Box
              sx={{
                overflow: "auto",
                height: "83vh",
                width: "100%",
                bgcolor: "#F9F9F9",
              }}
            >
              {activeStep === 0 && (
                <Suspense
                  fallback={<SuspenseLoading width="100%" height="90%" />}
                >
                  <CreatePostSelectTemplate
                    triggerValidation={triggerValidation}
                    setTriggerValidation={setTriggerValidation}
                    onNext={() => {
                      setActiveStep(0);
                      setActiveSubStep(1);
                    }}
                  />
                </Suspense>
              )}
              {activeStep === 0 && activeSubStep === 1 && (
                <>
                  <PostPreviewModal
                    open={true}
                    flag={flag}
                    onClose={() => {
                      setTriggerValidation(false);
                      setActiveSubStep(0);
                      // onClose();
                    }}
                    onPostSuccess={(jobStatus) =>
                      setSuccessModal({ open: true, jobStatus })
                    } // Store jobStatus
                  />
                </>
              )}
            </Box>
          </Box>
        </Box>
      </DialogContent>

      <DialogActions>
        <DialogActions
          sx={{
            justifyContent: "flex-end",
          }}
          onClick={onNext}
        >
          <Button
            variant="main"
            sx={{ px: 2, fontSize: "18px", fontWeight: 600 }}
          >
            {loading ? (
              <CircularProgress sx={{ color: "white" }} size={18} />
            ) : (
              "Next"
            )}
          </Button>
        </DialogActions>
      </DialogActions>
    </Dialog>
  );
};

export default RepostAJobModal;
